import { createHTML, organizeOccurrences } from "./utils";

export function exportHTML(
    occurrences,
    attributeForOrganize,
    includeUndefined,
    beautifulName,
    fileName = 'Relatório Conecta Canaã',
    includeServiceStart = false,
    includeResolutionTime = false
) {
    const organizedOccurrences = organizeOccurrences(occurrences, attributeForOrganize, includeUndefined);

    var htmlContent = createHTML(
        organizedOccurrences,
        fileName,
        occurrences.length,
        beautifulName,
        includeServiceStart,
        includeResolutionTime
    );

    var tempLink = document.createElement("a");
    var blobFile = new Blob([htmlContent], { type: "text/html" });

    tempLink.setAttribute('href', URL.createObjectURL(blobFile));
    tempLink.setAttribute('download', `${fileName}.html`);
    tempLink.click();

    URL.revokeObjectURL(tempLink.href);
}